module.exports = __webpack_public_path__ + "img/buying_title.9d5e629d.svg";